import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { session, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh', background: '#0d0d0d', color: '#888',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontFamily: 'Space Mono, monospace', fontSize: 13
      }}>
        Loading...
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/2gslikegucciadmin/login" replace />;
  }

  return children;
}


// import React from 'react';
// import { Navigate } from 'react-router-dom';
// import { useAuth } from '../context/AuthContext';

// export default function ProtectedRoute({ children }) {
//   const { session, loading } = useAuth();

//   if (loading) {
//     return (
//       <div style={{
//         minHeight: '100vh', background: '#0d0d0d', color: '#888',
//         display: 'flex', alignItems: 'center', justifyContent: 'center',
//         fontFamily: 'Space Mono, monospace', fontSize: 13
//       }}>
//         Loading...
//       </div>
//     );
//   }

//   if (!session) {
//     return <Navigate to="/admin/login" replace />;
//   }

//   return children;
// }
